module.exports = __webpack_public_path__ + "img/conductor-banner-1400.92da2b63.png";